import { useEffect } from 'react';
import useCurrentPage from '../hooks/use-set-current-page';
import Container from '../components/Container';
import Companies from '../components/Companies';

export default function Home() {
  const currentPage = useCurrentPage();
  useEffect(() => {
    currentPage.setCurrentPage('Portfolio');
  }, []);

  return (
    <div className="mb-auto bg-white lg:bg-ow-lighter-grey">
      <Container>
        <div className="lg:flex lg:justify-center lg:w-full">
          <div className="lg:w-full lg:bg-white lg:p-8">
            <div>
              <Companies defaultList={[]} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
